import React, { type ReactElement, useState } from 'react';
import { faRecycle } from '@fortawesome/free-solid-svg-icons';
import { toInteger } from 'lodash';
import TableActions from 'atom-components/table-actions-lite';
import ConfirmDeleteMarkModal from 'pages/marking/components/confirm-delete-mark-modal';
import MarkPolicy from 'policies/mark.policy';
import MarkingTaskPolicy from 'policies/marking-task.policy';
import type { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';
import { usePageAccess } from 'services/providers/page-access.provider';

type Props = {
  markId?: number;
  markStatus?: MarkStatus;
};

export default function DeleteMarkButton({ markId, markStatus }: Props): ReactElement {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { authorisableUser } = usePageAccess();

  // Note: Response markers are not relevant to the deletion scenario, but if that changes we'll
  // need to add them to authorisable mark.
  const authorisableMark = { id: markId, status: markStatus, responseMarkers: [] };

  return (
    <>
      <ConfirmDeleteMarkModal
        isOpen={isModalOpen}
        onClose={(): void => setIsModalOpen(false)}
        // markId should be considered a number. Modal can never appear if markId is undefined.
        markId={toInteger(markId)}
      />
      {MarkingTaskPolicy.administrate(authorisableUser) && (
        <TableActions.Button
          tooltip={markId ? 'Delete Mark' : `Cannot Delete Mark (marking hasn't started)`}
          onClick={(): void => setIsModalOpen(true)}
          icon={faRecycle}
          disabled={!MarkPolicy.delete(authorisableUser, authorisableMark)} // Actual authorisation.
          isDangerous
        />
      )}
    </>
  );
}
